enum DragItemType {
  DEVELOPMENT_FROM_HAND = 'DEVELOPMENT_FROM_HAND',
  DEVELOPMENT_FROM_DRAFT_AREA = 'DEVELOPMENT_FROM_DRAFT_AREA',
  DEVELOPMENT_FROM_CONSTRUCTION_AREA = 'DEVELOPMENT_FROM_CONSTRUCTION_AREA',
  RESOURCE_FROM_BOARD = 'RESOURCE_FROM_BOARD',
  KRYSTALLIUM_FROM_EMPIRE = 'KRYSTALLIUM_FROM_EMPIRE',
  CHARACTER_TOKEN_FROM_EMPIRE = 'CHARACTER_TOKEN_FROM_EMPIRE'
}

export default DragItemType